// ─── PERSONAL INFO ───────────────────────────────────────────────
export const personalInfo = {
  name: "Saniya Mane",
  firstName: "Saniya",
  lastName: "Mane",
  role: "Full Stack Developer",
  stack: "MERN Stack",
  tagline: "Building scalable, responsive, and user-focused web applications",
  subTagline: "Turning ideas into real-world digital solutions",
  email: "manesaniya0987@gmail.com",       
  linkedin: "https://www.linkedin.com/in/saniyamane/", 
  github: "https://github.com/saniya2701",        
  resume: "/Saniya Mane.pdf",              
  location: "Maharashtra, India",
  available: true,
};

// ─── TYPING ROLES ─────────────────────────────────────────────────
export const typingRoles = [
  "Full Stack Developer",
  "MERN Stack Engineer",
  "React Developer",
  "Node.js Developer",
  "Problem Solver",
];

// ─── ABOUT ────────────────────────────────────────────────────────
export const aboutParagraphs = [
  "I am a Computer Science Engineering student specializing in Full Stack Development. I build scalable and responsive web applications using the MERN stack.",
  "I focus on clean code, performance optimization, and delivering real-world solutions. My goal is to bridge the gap between great design and solid engineering.",
  "Beyond code, I actively contribute to developer communities — mentoring peers, organizing events, and continuously learning at the intersection of web and AI.",
];

export const highlights = [
  { icon: "🧩", title: "Problem Solver", desc: "Love turning complex problems into elegant solutions" },
  { icon: "⚡", title: "Fast Learner", desc: "Quickly adapt to new technologies and frameworks" },
  { icon: "🤝", title: "Team Player", desc: "Collaborative mindset with strong communication skills" },
];

export const stats = [
  { num: "3+", label: "Full Stack Projects" },
  { num: "3+", label: "Internships" },
  { num: "MERN", label: "Core Stack" },
  { num: "2+", label: "Leadership Roles" },
];

// ─── SKILLS ────────────────────────────────────────────────────────
export const skillCategories = [
  {
    id: "frontend",
    title: "Frontend",
    icon: "🎨",
    color: "purple",
    skills: [
      { name: "React.js", pct: 90 },
      { name: "Tailwind CSS", pct: 88 },
      { name: "HTML & CSS", pct: 95 },
      { name: "JavaScript (ES6+)", pct: 87 },
    ],
  },
  {
    id: "backend",
    title: "Backend",
    icon: "⚙️",
    color: "cyan",
    skills: [
      { name: "Node.js", pct: 82 },
      { name: "Express.js", pct: 80 },
      { name: "REST APIs", pct: 85 },
      { name: "JWT Auth", pct: 78 },
    ],
  },
  {
    id: "database",
    title: "Database",
    icon: "🗄️",
    color: "green",
    skills: [
      { name: "MongoDB", pct: 80 },
      { name: "MySQL", pct: 75 },
      { name: "Firebase", pct: 72 },
      { name: "Mongoose ODM", pct: 78 },
    ],
  },
  {
    id: "tools",
    title: "Tools & More",
    icon: "🛠️",
    color: "amber",
    skills: [
      { name: "Git & GitHub", pct: 88 },
      { name: "Postman", pct: 82 },
      { name: "Redux", pct: 75 },
      { name: "VS Code", pct: 92 },
    ],
  },
];

// ─── PROJECTS ──────────────────────────────────────────────────────
export const projects = [
  {
    id: 1,
    badge: "Featured",
    emoji: "📚",
    gradient: "from-violet-900/40 to-purple-900/40",
    title: "SkillNest – LMS Platform",
    problem: "Problem: Fragmented online learning experience",
    description:
      "Built a full-stack Learning Management System with course creation, student enrollment, progress tracking, and secure multi-role authentication — making education accessible and organized.",
    stack: ["React", "Redux", "Node.js", "MongoDB", "Express", "Tailwind"],
    features: [
      "Multi-role auth (Admin / Instructor / Student)",
      "Course creation with rich media support",
      "Progress tracking & quiz engine",
      "Responsive across all devices",
    ],
    impact:
      "40% faster page loads via code splitting · Role-based dashboards · Secure JWT sessions",
    liveUrl: "https://skill-nest-frontend-eight.vercel.app/", // ← Replace with live URL
    githubUrl: "https://github.com/Saniya2701/SkillNest-backend", // ← Replace with GitHub URL
  },
 {
  id: 2,
  badge: "Full Stack",
  emoji: "💼",
  gradient: "from-blue-900/40 to-indigo-900/40",
  title: "DevConnect",
  problem: "Problem: Building a scalable professional networking platform with real-world social features",
  description:
    "Designed and developed a full-stack LinkedIn-inspired networking platform with authentication, profile management, post sharing, and connection features — demonstrating scalable social media application architecture.",
  stack: ["React", "Node.js", "Express", "MongoDB", "JWT", "Tailwind CSS"],
  features: [
    "JWT-based authentication & protected routes",
    "Profile creation and connection system",
    "Post sharing & social interaction features",
    "Responsive modern networking platform UI",
  ],
  impact:
    "Scalable MERN architecture · Secure authentication system · Real-world networking workflows",
  liveUrl: "#",
  githubUrl: "#",
},
 {
  id: 3,
  badge: "Mobile App",
  emoji: "📱",
  gradient: "from-pink-900/40 to-rose-900/40",
  title: "SmartHelpApp",
  problem: "Problem: Providing quick emergency assistance and smart support access through mobile devices",
  description:
    "Developed an Android-based smart assistance application focused on improving emergency communication, accessibility, and user support workflows through an intuitive mobile-first experience.",
  stack: ["Java", "Android Studio", "Firebase", "XML"],
  features: [
    "Real-time emergency assistance workflows",
    "Firebase-based authentication & data storage",
    "User-friendly Android mobile interface",
    "Optimized navigation & responsive UI design",
  ],
  impact:
    "Mobile-first architecture · Real-time assistance workflows · Optimized Android user experience",
  liveUrl: "#",
  githubUrl: "https://github.com/Saniya2701/SmartHelpApp",
},
  {
  id: 4,
  badge: "AI Automation",
  emoji: "🤖",
  gradient: "from-orange-900/40 to-yellow-900/40",
  title: "Multi Support Triage Agent",
  problem: "Problem: Reducing manual customer support workload through intelligent automation",
  description:
    "Built an AI-powered support automation system that classified, prioritized, and resolved customer support tickets using confidence-based decision workflows and automated reporting pipelines.",
  stack: ["Python", "Automation Logic", "CSV Processing"],
  features: [
    "Automated ticket classification system",
    "Confidence-based escalation workflows",
    "CSV report generation & processing",
    "Intelligent support ticket prioritization",
  ],
  impact:
    "93% ticket resolution automation · Reduced manual support effort · Streamlined customer support operations",
  liveUrl: "#",
  githubUrl: "https://github.com/Saniya2701/multi-support-triage-agent",
},
  
];

// ─── EXPERIENCE ────────────────────────────────────────────────────
export const experiences = [
  {
    id: 1,
    role: "Frontend Web Developer Intern",
    org: "IBM SkillsBuild",
    period: "Aug 2025 – Sep 2025",
    color: "purple",
    bullets: [
      "Built responsive UI components with accessibility-first approach",
      "Improved website usability and interaction design patterns",
      "Collaborated with senior engineers on production deployments",
    ],
  },
  {
    id: 2,
    role: "Full Stack Web Developer Intern",
    org: "Unified Mentor",
    period: "Apr 2025 – May 2025",
    color: "cyan",
    bullets: [
      "Developed web applications end-to-end using the MERN stack",
      "Enhanced frontend performance through optimization techniques",
      "Delivered 2 complete modules from design to deployment",
    ],
  },
  {
    id: 3,
    role: "AIML Intern",
    org: "Google for Developers",
    period: "Oct 2024 – Dec 2024",
    color: "green",
    bullets: [
      "Worked on AI/ML concepts, model evaluation, and applied prototypes",
      "Gained cross-disciplinary exposure to ML-driven product thinking",
      "Completed hands-on labs with TensorFlow and Python ecosystems",
    ],
  },
];

// ─── LEADERSHIP ────────────────────────────────────────────────────
export const leadership = [
  {
    id: 1,
    icon: "👑",
    title: "Head – HackerRank Campus Crew",
    org: "HackerRank × DYPCET",
    color: "purple",
    desc: "Led a campus-wide developer community, organizing coding contests and workshops.",
  },
  {
    id: 2,
    icon: "🎓",
    title: "LLC Mentor",
    org: "Microsoft Learn Student Ambassadors (MLSA)",
    color: "cyan",
    desc: "Mentored students on Microsoft technologies, learning paths, and career development.",
  },
  {
    id: 3,
    icon: "🌱",
    title: "Volunteer",
    org: "GDG on Campus",
    color: "green",
    desc: "Volunteered at Google Developer Group events, supporting speakers and attendees.",
  },
];

// ─── ACHIEVEMENTS ──────────────────────────────────────────────────
export const achievements = [
  {
    icon: "🚀",
    title: "Full Stack Builder",
    desc: "Built production-grade MERN apps with auth, REST APIs, and responsive UIs",
  },
  {
    icon: "🏢",
    title: "Industry Exposure",
    desc: "3 internships across IBM, Google for Developers, and Unified Mentor",
  },
  {
    icon: "🌐",
    title: "Community Active",
    desc: "Active in HackerRank, MLSA, and GDG — grows skills and gives back",
  },
  {
    icon: "🧠",
    title: "Continuous Learner",
    desc: "Explores AI/ML alongside web development, always expanding the toolkit",
  },
];
